import { styled } from 'styled-components';

export const Wrapper = styled.div<{
    $color?: IconProps['color'];
}>`
    width: 1em;
    height: 1em;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    & svg,
    & path {
        color: ${({ $color }) =>
            $color === 'error' ? 'var(--color-error)' : 'var(--color-primary)'};
    }
`;
